import { render, staticRenderFns } from "./EditBuddycomCallSetting.vue?vue&type=template&id=4a94b09a&scoped=true"
import script from "./EditBuddycomCallSetting.vue?vue&type=script&lang=js"
export * from "./EditBuddycomCallSetting.vue?vue&type=script&lang=js"
import style0 from "./EditBuddycomCallSetting.vue?vue&type=style&index=0&id=4a94b09a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94b09a",
  null
  
)

export default component.exports